export function getFileTypeFromContentType(contentType: string): string {
  if (!contentType) return 'unknown';

  const lower = contentType.toLowerCase();

  if (
    [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/heic',
      'image/heif',
      'image/gif',
      'image/bmp',
      'image/tiff',
      'image/svg+xml',
    ].includes(lower)
  ) {
    return 'img';
  }

  if (['application/pdf'].includes(lower)) {
    return 'pdf';
  }

  if (
    [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ].includes(lower)
  ) {
    return 'doc';
  }

  if (
    [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
    ].includes(lower)
  ) {
    return 'xls';
  }

  if (lower === 'text/plain') {
    return 'txt';
  }

  if (
    [
      'application/zip',
      'application/x-zip-compressed',
      'multipart/x-zip',
      'application/x-compressed',
    ].includes(lower)
  ) {
    return 'zip';
  }

  if (
    [
      'image/vnd.dwg',
      'application/acad',
      'application/x-autocad',
      'application/x-dwg',
      'application/dwg',
    ].includes(lower)
  ) {
    return 'dwg';
  }

  if (['video/mp4', 'video/quicktime', 'video/x-msvideo'].includes(lower)) {
    return 'video';
  }

  if (['audio/mp4', 'audio/m4a', 'audio/mpeg'].includes(lower)) {
    return 'audio';
  }

  return 'file';
}

export async function throttleAsync<T>(
  tasks: (() => Promise<T>)[],
  maxConcurrent: number,
): Promise<T[]> {
  const results: T[] = [];
  const executing: Promise<void>[] = [];

  for (const task of tasks) {
    const p = task().then((result) => {
      results.push(result);
    });

    executing.push(p);

    if (executing.length >= maxConcurrent) {
      await Promise.race(executing);
      void executing.splice(
        executing.findIndex((e) => e === p),
        1,
      );
    }
  }

  await Promise.all(executing);
  return results;
}
